"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function get() {
    return _chunkB15f.a;
  }
});
Object.defineProperty(exports, "Flex", {
  enumerable: true,
  get: function get() {
    return _chunkB15f.b;
  }
});
exports.breakpoints = exports.breakpointsEM = exports.media = exports.CGrid = exports.CCol = exports.CRow = exports.Column = exports.Row = exports.Grid = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chunkB15f = require("./chunk-b15f6972.js");

var _chunk48de = require("./chunk-48de8464.js");

require("react");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fill,\n    minmax(", "px, 1fr)\n  );\n  row-gap: ", "px;\n  column-gap: ", "px;\n  width: 100%;\n\n  & > * {\n    width: 100%;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Grid = (0, _styledComponents.default)(_chunkB15f.a).withConfig({
  displayName: "layout__Grid",
  componentId: "sc-1wiiq5b-0"
})(_templateObject(), function (props) {
  return props.minItemWidths[0] || props.minItemWidth;
}, function (props) {
  return props.gutter;
}, function (props) {
  return props.gutter;
}, function (props) {
  return props.minItemWidths && props.minItemWidths.slice(1).map(function (_ref) {
    var _ref2 = (0, _chunkB2edacfb.l)(_ref, 2),
        breakpoint = _ref2[0],
        minItemWidth = _ref2[1];

    return "\n      @media (max-width: ".concat(breakpoint, "px) {\n        grid-template-columns: repeat(\n          auto-fill,\n          minmax(").concat(minItemWidth, "px, 1fr)\n        );\n      }\n    ");
  });
});
exports.Grid = Grid;
Grid.displayName = "Grid";
Grid.propTypes = {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  minItemWidth: _propTypes.default.number,
  minItemWidths: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.number))
};
Grid.defaultProps = {
  gutter: 24,
  minItemWidth: 315,
  minItemWidths: []
};

function _templateObject$1() {
  var data = (0, _chunkB2edacfb.a)(["\n  ", "\n  margin-left: -", "px;\n  width: calc(\n    100% + ", "px\n  );\n\n  & > * {\n    ", "\n    margin-left: ", "px;\n    ", "\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Row = (0, _styledComponents.default)(_chunkB15f.b).withConfig({
  displayName: "layout__Row",
  componentId: "sc-1wiiq5b-1"
})(_templateObject$1(), function (props) {
  return props.flexWrap === "wrap" ? "\n    margin-top: -".concat(props.gutterY === null ? props.gutter : props.gutterY, "px;\n  ") : "";
}, function (props) {
  return props.gutterX === null ? props.gutter : props.gutterX;
}, function (props) {
  return props.gutterX === null ? props.gutter : props.gutterX;
}, function (props) {
  return props.flexWrap === "wrap" ? "\n      margin-top: ".concat(props.gutterY === null ? props.gutter : props.gutterY, "px;\n    ") : "";
}, function (props) {
  return props.gutterX === null ? props.gutter : props.gutterX;
}, function (props) {
  return props.setChildrenEqualSize ? "flex-grow: 1; width: 100%;" : "";
});
exports.Row = Row;
Row.displayName = "Row";
Row.propTypes = {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  gutterX: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  gutterY: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  alignItems: _propTypes.default.string,
  justifyContent: _propTypes.default.string,
  setChildrenEqualSize: _propTypes.default.bool
};
Row.defaultProps = {
  gutter: 24,
  gutterX: null,
  gutterY: null,
  alignItems: "flex-start",
  justifyContent: "normal",
  setChildrenEqualSize: false
};

function _templateObject$2() {
  var data = (0, _chunkB2edacfb.a)(["\n  flex-direction: column;\n  margin-top: -", "px;\n  ", "\n\n  & > * {\n    margin-top: ", "px;\n    ", "\n\n    ", "\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Column = (0, _styledComponents.default)(_chunkB15f.b).withConfig({
  displayName: "layout__Column",
  componentId: "sc-1wiiq5b-2"
})(_templateObject$2(), function (props) {
  return props.gutterY === null ? props.gutter : props.gutterY;
}, function (props) {
  return props.flexWrap === "wrap" ? "margin-left: -".concat(props.gutterX === null ? props.gutter : props.gutterX, "px;") : "";
}, function (props) {
  return props.gutterY === null ? props.gutter : props.gutterY;
}, function (props) {
  return props.flexWrap === "wrap" ? "margin-left: ".concat(props.gutterX === null ? props.gutter : props.gutterX, "px;") : "";
}, function (props) {
  return props.setChildrenEqualSize ? "height: 100%;" : "";
});
exports.Column = Column;
Column.displayName = "Column";
Column.propTypes = {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  gutterX: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  gutterY: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  alignItems: _propTypes.default.string,
  justifyContent: _propTypes.default.string,
  setChildrenEqualSize: _propTypes.default.bool
};
Column.defaultProps = {
  gutter: 24,
  gutterX: null,
  gutterY: null,
  alignItems: "flex-start",
  justifyContent: "normal",
  setChildrenEqualSize: false
};
var THEME_CONF = "flexboxgrid";
var BASE_CONF = {
  gridSize: 12,
  gutterWidth: 1,
  outerMargin: 2,
  mediaQuery: "only screen",
  container: {
    sm: 46,
    md: 61,
    lg: 76
  },
  breakpoints: {
    xs: 0,
    sm: 48,
    md: 64,
    lg: 75
  }
};
var configCache = [];

var makeCacheId = function makeCacheId(props) {
  return JSON.stringify(props.theme && props.theme[THEME_CONF] || {});
};

var resolveConfig = function resolveConfig(props) {
  var themeConf = props.theme && props.theme[THEME_CONF] || {};
  var conf = (0, _chunkB2edacfb.i)({}, BASE_CONF, {}, themeConf, {
    container: (0, _chunkB2edacfb.i)({}, BASE_CONF.container, {}, themeConf.container),
    breakpoints: (0, _chunkB2edacfb.i)({}, BASE_CONF.breakpoints, {}, themeConf.breakpoints)
  });
  conf.media = Object.keys(conf.breakpoints).reduce(function (media, breakpoint) {
    var breakpointWidth = conf.breakpoints[breakpoint];
    media[breakpoint] = makeMedia([conf.mediaQuery, breakpoint !== 0 && "(min-width: ".concat(breakpointWidth, "em)")].filter(Boolean).join(" and "));
    return media;
  }, {});
  return conf;
};

var DIMENSION_NAMES = ["xs", "sm", "md", "lg"];

function config(props) {
  var cacheId = makeCacheId(props);

  if (configCache[0] === cacheId) {
    return configCache[1];
  }

  var conf = resolveConfig(props);
  configCache[0] = cacheId;
  configCache[1] = conf;
  return conf;
}

function makeMedia(media) {
  return function () {
    return (0, _styledComponents.css)(["@media ", "{", "}"], media, _styledComponents.css.apply(void 0, arguments));
  };
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n        width: ", "rem;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = (0, _chunkB2edacfb.a)(["\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: ", ";\n  padding-left: ", ";\n\n  ", "\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var CGrid = _styledComponents.default.div.withConfig({
  displayName: "layout__CGrid",
  componentId: "sc-1wiiq5b-3"
})(_templateObject$3(), function (p) {
  return config(p).outerMargin + "rem";
}, function (p) {
  return config(p).outerMargin + "rem";
}, function (p) {
  return !p.fluid && (0, _styledComponents.css)(["", ""], DIMENSION_NAMES.map(function (t) {
    return config(p).container[t] && config(p).media[t](_templateObject2(), function (p) {
      return config(p).container[t];
    });
  }));
});

exports.CGrid = CGrid;
CGrid.displayName = "CGrid";
CGrid.propTypes = {
  fluid: _propTypes.default.bool,
  children: _propTypes.default.node
};

function _templateObject11() {
  var data = (0, _chunkB2edacfb.a)(["\n    order: 1;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _chunkB2edacfb.a)(["\n    order: -1;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _chunkB2edacfb.a)(["\n    justify-content: space-between;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _chunkB2edacfb.a)(["\n    justify-content: space-around;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _chunkB2edacfb.a)(["\n    align-items: flex-end;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _chunkB2edacfb.a)(["\n    align-items: center;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _chunkB2edacfb.a)(["\n    align-items: flex-start;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n    justify-content: flex-end;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n    justify-content: center;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = (0, _chunkB2edacfb.a)(["\n    justify-content: flex-start;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = (0, _chunkB2edacfb.a)(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ", "rem;\n  margin-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n   ", "\n  ", "\n  ", "\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var ModificatorType = _propTypes.default.oneOf(DIMENSION_NAMES);

var CRow = _styledComponents.default.div.withConfig({
  displayName: "layout__CRow",
  componentId: "sc-1wiiq5b-4"
})(_templateObject$4(), function (p) {
  return config(p).gutterWidth / 2 * -1;
}, function (p) {
  return config(p).gutterWidth / 2 * -1;
}, function (p) {
  return p.reverse && "\n    flex-direction: row-reverse;\n  ";
}, function (p) {
  return p.start && config(p).media[p.start](_templateObject2$1());
}, function (p) {
  return p.center && config(p).media[p.center](_templateObject3());
}, function (p) {
  return p.end && config(p).media[p.end](_templateObject4());
}, function (p) {
  return p.top && config(p).media[p.top](_templateObject5());
}, function (p) {
  return p.middle && config(p).media[p.middle](_templateObject6());
}, function (p) {
  return p.bottom && config(p).media[p.bottom](_templateObject7());
}, function (p) {
  return p.around && config(p).media[p.around](_templateObject8());
}, function (p) {
  return p.between && config(p).media[p.between](_templateObject9());
}, function (p) {
  return p.first && config(p).media[p.first](_templateObject10());
}, function (p) {
  return p.last && config(p).media[p.last](_templateObject11());
}, function (p) {
  return p.fullWidth && "\n    width: 100%;\n  ";
}, function (p) {
  return p.marginBottom && "\n    margin-bottom: ".concat(p.marginBottom, ";\n  ");
}, function (p) {
  return p.marginTop && "\n    margin-top: ".concat(p.marginTop, ";\n  ");
});

exports.CRow = CRow;
CRow.displayName = "CRow";
CRow.propTypes = {
  reverse: _propTypes.default.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType,
  first: ModificatorType,
  last: ModificatorType,
  children: _propTypes.default.node,
  fullWidth: _propTypes.default.bool
};
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;
var symbolTag = '[object Symbol]';
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var objectProto = Object.prototype;
var objectToString = objectProto.toString;

function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

function isObject(value) {
  var type = _typeof(value);

  return !!value && (type == 'object' || type == 'function');
}

function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var lodash_isinteger = isInteger;

function _templateObject3$1() {
  var data = (0, _chunkB2edacfb.a)(["\n        margin-left: ", "%;\n      "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = (0, _chunkB2edacfb.a)(["", ""]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = (0, _chunkB2edacfb.a)(["\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding-right: ", "rem;\n  padding-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var ModificatorType$1 = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]);

var offsetProps = DIMENSION_NAMES.map(function (d) {
  return d + "Offset";
});
var DimensionPropTypes = DIMENSION_NAMES.reduce(function (propTypes, dimension) {
  propTypes[dimension] = ModificatorType$1;
  propTypes[dimension + "Offset"] = _propTypes.default.number;
  return propTypes;
}, {});

var CCol = _styledComponents.default.div.withConfig({
  displayName: "layout__CCol",
  componentId: "sc-1wiiq5b-5"
})(_templateObject$5(), function (p) {
  return config(p).gutterWidth / 2;
}, function (p) {
  return config(p).gutterWidth / 2;
}, function (p) {
  return p.reverse && "\n    flex-direction: column-reverse;\n  ";
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~DIMENSION_NAMES.indexOf(k);
  }).sort(function (k1, k2) {
    return DIMENSION_NAMES.indexOf(k1) - DIMENSION_NAMES.indexOf(k2);
  }).map(function (k) {
    return config(p).media[k](_templateObject2$2(), lodash_isinteger(p[k]) ? "\n        flex-basis: ".concat(100 / config(p).gridSize * p[k], "%;\n        max-width: ").concat(100 / config(p).gridSize * p[k], "%;\n        display: block;\n      ") : p[k] ? "\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n          display: block;\n        " : "display: none;");
  });
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~offsetProps.indexOf(k);
  }).map(function (k) {
    return config(p).media[k.replace(/Offset$/, "")](_templateObject3$1(), 100 / config(p).gridSize * p[k]);
  });
});

exports.CCol = CCol;
CCol.displayName = "CCol";
CCol.propTypes = (0, _chunkB2edacfb.i)({}, DimensionPropTypes, {
  reverse: _propTypes.default.bool,
  children: _propTypes.default.node
});

var emTopx = function emTopx(em) {
  return em * 16;
};

var breakpoints = {
  xs: emTopx(_chunk48de.a.flexboxgrid.breakpoints.xs),
  sm: emTopx(_chunk48de.a.flexboxgrid.breakpoints.sm),
  md: emTopx(_chunk48de.a.flexboxgrid.breakpoints.md),
  lg: emTopx(_chunk48de.a.flexboxgrid.breakpoints.lg)
};
exports.breakpoints = breakpoints;
var breakpointsEM = {
  xs: "".concat(_chunk48de.a.flexboxgrid.breakpoints.xs, "em"),
  sm: "".concat(_chunk48de.a.flexboxgrid.breakpoints.sm, "em"),
  md: "".concat(_chunk48de.a.flexboxgrid.breakpoints.md, "em"),
  lg: "".concat(_chunk48de.a.flexboxgrid.breakpoints.lg, "em")
};
exports.breakpointsEM = breakpointsEM;

function getSizeFromBreakpoint(breakpointValue) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (breakpoints[breakpointValue]) {
    return breakpoints[breakpointValue];
  } else if (parseInt(breakpointValue)) {
    return breakpointValue;
  } else {
    console.error("styled-media-query: No valid breakpoint or size specified for media.");
    return "0";
  }
}

function generateMedia() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : breakpointsEM;

  var lessThan = function lessThan(breakpoint) {
    return function () {
      return (0, _styledComponents.css)(["@media (max-width:", "){", "}"], getSizeFromBreakpoint(breakpoint, breakpoints), _styledComponents.css.apply(void 0, arguments));
    };
  };

  var greaterThan = function greaterThan(breakpoint) {
    return function () {
      return (0, _styledComponents.css)(["@media (min-width:", "){", "}"], getSizeFromBreakpoint(breakpoint, breakpoints), _styledComponents.css.apply(void 0, arguments));
    };
  };

  var between = function between(firstBreakpoint, secondBreakpoint) {
    return function () {
      return (0, _styledComponents.css)(["@media (min-width:", ") and (max-width:", "){", "}"], getSizeFromBreakpoint(firstBreakpoint, breakpoints), getSizeFromBreakpoint(secondBreakpoint, breakpoints), _styledComponents.css.apply(void 0, arguments));
    };
  };

  return Object.assign({
    lessThan: lessThan,
    greaterThan: greaterThan,
    between: between
  });
}

var Media = generateMedia();
exports.media = Media;